"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
import { TagsModel } from "../tags.model";
export let PaymentPurchaseModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.sort = 0;
    this.price = 0;
    this.period = "";
    this.originalPrice = 0;
    this.marks = new TagsModel();
    this.description = "";
    this.tag = null;
    this.currency = "";
    this.payments = [];
    this.leftTags = null;
    this.infoTags = null;
    this.rightupperTags = null;
    this.additionalPurchase = [];
  }
};
PaymentPurchaseModel.model = "safety_manager";
PaymentPurchaseModel = __decorateClass([
  Annotation.ModelMeta
], PaymentPurchaseModel);
export let PaymentPurchaseSelectedModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.selectedProduct = new PaymentPurchaseModel();
    // 全部鲸豆
    this.paymentGoldbeanCoins = 0;
    // 使用的鲸豆数量上限
    this.paymentGoldbeanLimit = 0;
    // 剩余鲸豆数量
    this.paymentGoldbeanLeft = 0;
    // 使用的鲸豆数量
    this.paymentGoldbeanUsed = 0;
    // 选择的额外加购监管名额数量
    this.selectedAdditionalQuota = 0;
    // 选择的额外加购监管名额ID
    this.selectedAdditionalId = "";
    // 自动续费
    this.selectedautoRenewal = false;
    // 选择的支付方式
    this.paymentMethod = "alipay";
  }
};
PaymentPurchaseSelectedModel.model = "payment.purchase.selected";
PaymentPurchaseSelectedModel = __decorateClass([
  Annotation.ModelMeta
], PaymentPurchaseSelectedModel);
export let OrderModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
  }
};
OrderModel.model = "order.result";
OrderModel = __decorateClass([
  Annotation.ModelMeta
], OrderModel);
export let InProcessSupervisionQuotaModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    this.id = "";
    this.name = "";
    this.sort = 0;
    this.price = 0;
    this.originalPrice = 0;
    this.marks = new TagsModel();
    this.description = "";
    this.tag = null;
    this.currency = "";
    this.payments = [];
    this.leftTags = null;
    this.infoTags = null;
    this.rightupperTags = null;
    this.expiredTime = 0;
    // 全部鲸豆
    this.paymentGoldbeanCoins = 0;
    // 使用的鲸豆数量上限
    this.paymentGoldbeanLimit = 0;
    // 剩余鲸豆数量
    this.paymentGoldbeanLeft = 0;
    // 使用的鲸豆数量
    this.paymentGoldbeanUsed = 0;
    // 选择的额外加购监管名额数量
    this.selectedAdditionalQuota = 0;
    // 选择的支付方式
    this.paymentMethod = "alipay";
  }
};
InProcessSupervisionQuotaModel.model = "in_process_supervision_quota";
InProcessSupervisionQuotaModel = __decorateClass([
  Annotation.ModelMeta
], InProcessSupervisionQuotaModel);
